import { SVGProps } from "react";

const BIBxsCartAlt = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}><path d="M21 4H2v2h2.3l3.521 9.683A2.004 2.004 0 0 0 9.7 17H18v-2H9.7l-.728-2H18c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 4z" /><circle cx={10.5} cy={19.5} r={1.5} /><circle cx={16.5} cy={19.5} r={1.5} /></svg>;

export { BIBxsCartAlt };